// class NewsletterPopup extends HTMLElement {
//   constructor() {
//     super();

//     // Element references
//     this.popup = this;
//     this.timeToShow = parseInt(this.popup.getAttribute('data-delay') || '0', 10);
//     this.expiresDays = parseInt(this.popup.getAttribute('data-expire') || '30', 10);

//     // Auto-show once only
//     if (!this.getCookie('newsletter-popup')) {
//       // Set the cookie immediately to ensure it shows only once
//       this.setCookie('newsletter-popup', 'shown', this.expiresDays);

//       // Show the popup after the delay
//       setTimeout(() => {
//         document.body.classList.add('newsletter-show');

//         // Optional: add image reveal effect
//         setTimeout(() => {
//           document.body.classList.add('show-newsletter-image');
//         }, 700);
//       }, this.timeToShow);
//     }

//     // Close button handler
//     const closeBtn = this.querySelector('[data-close-newsletter-popup]');
//     if (closeBtn) {
//       closeBtn.addEventListener('click', this.close.bind(this));
//     }

//     // Form submit handler
//     const form = this.querySelector('#ContactPopup');
//     if (form) {
//       form.addEventListener('submit', this.close.bind(this));
//     }

//     // Click outside the popup to close
//     document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
//   }

//   // Set cookie
//   setCookie(name, value, days) {
//     const d = new Date();
//     d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
//     const expires = 'expires=' + d.toUTCString();
//     document.cookie = `${name}=${value};${expires};path=/`;
//   }

//   // Get cookie
//   getCookie(name) {
//     const prefix = name + '=';
//     const ca = document.cookie.split(';');
//     for (let i = 0; i < ca.length; i++) {
//       let c = ca[i].trim();
//       if (c.indexOf(prefix) === 0) {
//         return c.substring(prefix.length, c.length);
//       }
//     }
//     return null;
//   }

//   // Close the popup
//   close() {
//     document.body.classList.remove('newsletter-show');
//     setTimeout(() => {
//       document.body.classList.remove('show-newsletter-image');
//     }, 700);
//   }

//   // Close when clicking outside the popup
//   onBodyClickEvent(event) {
//     if (
//       !this.contains(event.target) &&
//       !event.target.closest('[data-open-newsletter-popup]') &&
//       document.body.classList.contains('newsletter-show')
//     ) {
//       this.close();
//     }
//   }
// }

// customElements.define('newsletter-popup', NewsletterPopup);

// // Newsletter message popup logic (unchanged)
// class NewsletterMessagePopup extends HTMLElement {
//   constructor() {
//     super();

//     const closeBtn = this.querySelector('[data-close-newsletter-message-popup]');
//     if (closeBtn) {
//       closeBtn.addEventListener('click', this.close.bind(this));
//     }

//     document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
//   }

//   close() {
//     document.body.classList.remove('newsletter-message-show');
//   }

//   onBodyClickEvent(event) {
//     if (!this.contains(event.target)) {
//       this.close();
//     }
//   }
// }

// customElements.define('newsletter-message-popup', NewsletterMessagePopup);


class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    // Element references
    this.popup = this;
    this.timeToShow = parseInt(this.popup.getAttribute('data-delay') || '0', 10);
    // Set default expiry to 90 days
    this.expiresDays = parseInt(this.popup.getAttribute('data-expire') || '90', 10);

    // Auto-show once only
    if (!this.getCookie('newsletter-popup')) {
      // Set the cookie immediately to ensure it shows only once
      this.setCookie('newsletter-popup', 'shown', this.expiresDays);

      // Show the popup after the delay
      setTimeout(() => {
        document.body.classList.add('newsletter-show');

        // Optional: add image reveal effect
        setTimeout(() => {
          document.body.classList.add('show-newsletter-image');
        }, 700);
      }, this.timeToShow);
    }

    // Close button handler
    const closeBtn = this.querySelector('[data-close-newsletter-popup]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }

    // Form submit handler
    const form = this.querySelector('#ContactPopup');
    if (form) {
      form.addEventListener('submit', this.close.bind(this));
    }

    // Click outside the popup to close
    document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
  }

  // Set cookie
  setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  }

  // Get cookie
  getCookie(name) {
    const prefix = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(prefix) === 0) {
        return c.substring(prefix.length, c.length);
      }
    }
    return null;
  }

  // Close the popup
  close() {
    document.body.classList.remove('newsletter-show');
    setTimeout(() => {
      document.body.classList.remove('show-newsletter-image');
    }, 700);
  }

  // Close when clicking outside the popup
  onBodyClickEvent(event) {
    if (
      !this.contains(event.target) &&
      !event.target.closest('[data-open-newsletter-popup]') &&
      document.body.classList.contains('newsletter-show')
    ) {
      this.close();
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);

// Newsletter message popup logic (unchanged)
class NewsletterMessagePopup extends HTMLElement {
  constructor() {
    super();

    const closeBtn = this.querySelector('[data-close-newsletter-message-popup]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }

    document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
  }

  close() {
    document.body.classList.remove('newsletter-message-show');
  }

  onBodyClickEvent(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);
